import css from 'styled-jsx/css';

import Theme from 'styles/theme';

export default css`
  .typography--senary-heading {
    font-weight: ${Theme.get('font-weight-bold')};
    font-size: 12px;
    line-height: 1.75;
    letter-spacing: 1.7px;
    text-transform: uppercase;
    margin: 0;
    padding: 0;
  }
`;
